import { ApiCaller } from '../../../../api-caller.service';
import { EtxeAgentCardsAdminConnector } from './agent-cards/agent-cards.admin.connector';
import { EtxeAgentsAdminConnector } from './agents/agents.admin.connector';
import { EtxePropertiesAdminConnector } from './properties/properties.admin.connector';

export class EtxeAdminConnector {
  constructor(
    private apiCaller: ApiCaller,
    private prefix: string,
  ) {}

  agentCards = () => new EtxeAgentCardsAdminConnector(this.apiCaller, this.prefix);
  agents = () => new EtxeAgentsAdminConnector(this.apiCaller, this.prefix);
  properties = () => new EtxePropertiesAdminConnector(this.apiCaller, this.prefix);
}
